<template>
  <div class="col-md-12">
    <form name="newDocument" @submit.prevent="handleSubmit()">
      <div class="modal-body">
        <label>Serial Number :</label>

        <input
          v-validate="'required'"
          name="SerialNo"
          v-model="encodingData.SerialNo"
          class="form-control"
          :class="{ 'is-invalid': submitted && errors.has('SerialNo') }"
        />

        <span
          v-if="submitted && errors.has('SerialNo')"
          class="invalid-feedback"
          >{{ errors.first("SerialNo") }}</span
        >

        <label>Make :</label>

        <input name="Make" v-model="encodingData.Make" class="form-control" />

        <label>Caliber :</label>

        <input
          name="Caliber"
          v-model="encodingData.Caliber"
          class="form-control"
        />

        <label>Model :</label>

        <input name="Model" v-model="encodingData.Model" class="form-control" />

        <label>Comments :</label>

        <textarea
          name="Comments"
          v-model="encodingData.Comments"
          rows="5"
          cols="5"
          class="form-control"
        />
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import {
  authHeader,
  responseCheck,
  notifyHelper,
  EncodeURL,
  DataURL,
} from "../../helper";
import instance from "../../helper/http";
export default {
  data() {
    return {
      encodingData: {
        FirearmId: "",
        SerialNo: "",
        Make: "",
        Caliber: "",
        Model: "",
        Comments: "",
      },
      submitted: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  created: function () {
    this.getFireArms();
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          instance
            .post(EncodeURL + "updatefirearms", this.encodingData, {
              headers: authHeader(),
            })
            .then((response) => {
              if (response.data.error) {
                loader.hide()
                notifyHelper("error", response.data.message);
              } else {
                loader.hide()
                notifyHelper("success", response.data.message);
                this.$emit("done-edit-firearms");
              }
            })
            .catch(function (error) {
              responseCheck(error.response.status);
            });
        }
      });
    },
    getFireArms() {
      
      instance
        .get(DataURL + "firearms?firearmsID=" + this.id, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.data.error === false) {
            if (response.data.withdata) {
              let data = response.data.data;
              this.encodingData.FirearmId = data.firearmId;
              this.encodingData.SerialNo = data.serialNo;
              this.encodingData.Make = data.make;
              this.encodingData.Caliber = data.caliber;
              this.encodingData.Model = data.model;
              this.encodingData.Comments = data.comments;
            }
          }
        })
        .catch(function (error) {
          responseCheck(error.response.status);
        })
    },
  },
};
</script>
